import { generator } from '../event-listener.js';
export const OnSelectGroup = generator('onSelectGroup');
export const OnSelectItem = generator('onSelectItem');
export const OnUnselectGroup = generator('onUnselectGroup');
export const OnUnselectItem = generator('onUnselectItem');
//# sourceMappingURL=selectable-list.js.map